(() => {
  if (window.osloCardGalleryLoaded) return;
  window.osloCardGalleryLoaded = true;

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-oslo-gallery-direction]');
    if (!button) return;

    const galleryId = button.getAttribute('aria-controls');
    const gallery = galleryId ? document.getElementById(galleryId) : null;
    if (!gallery) return;

    const images = Array.from(gallery.querySelectorAll('.oslo-card-gallery__image'));
    if (images.length < 2) return;

    event.preventDefault();
    event.stopPropagation();

    const currentIndex = images.findIndex((image) => !image.hidden);
    const direction = Number(button.dataset.osloGalleryDirection) || 1;
    const nextIndex = (Math.max(currentIndex, 0) + direction + images.length) % images.length;

    images.forEach((image, index) => {
      const isCurrent = index === nextIndex;
      image.hidden = !isCurrent;
      image.setAttribute('aria-hidden', String(!isCurrent));
    });
  });
})();